import { render } from "./SpFooter.vue?vue&type=template&id=950e43d2"
import script from "./SpFooter.vue?vue&type=script&lang=js"
export * from "./SpFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__